var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.511,
    height: 34.805,
    viewBox: "0 0 26.511 34.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-docs",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Docs_3_",
    transform: "translate(61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6384",
    "data-name": "Group 6384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6383",
    "data-name": "Group 6383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6382",
    "data-name": "Group 6382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6381",
    "data-name": "Group 6381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13295",
    "data-name": "Path 13295",
    d: "M87.511,9.177,80.374,7.138,78.334,0H64.059A3.059,3.059,0,0,0,61,3.059V31.746A3.059,3.059,0,0,0,64.059,34.8H84.452a3.059,3.059,0,0,0,3.059-3.059Z",
    transform: "translate(-61)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13296",
    "data-name": "Path 13296",
    d: "M269.256,9.177V31.746A3.059,3.059,0,0,1,266.2,34.8H256V0h4.079l2.039,7.138Z",
    transform: "translate(-242.744)",
    fill: "#e7f2f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13297",
    "data-name": "Path 13297",
    d: "M325.177,9.177h-7.138A2.045,2.045,0,0,1,316,7.138V0a.956.956,0,0,1,.714.306l8.157,8.157A.956.956,0,0,1,325.177,9.177Z",
    transform: "translate(-298.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6385",
    "data-name": "Group 6385",
    transform: "translate(6.118 14.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13298",
    "data-name": "Path 13298",
    d: "M164.256,213.039H152.02a1.02,1.02,0,1,1,0-2.039h12.236a1.02,1.02,0,0,1,0,2.039Z",
    transform: "translate(-151 -211)",
    fill: "#4cb3c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6386",
    "data-name": "Group 6386",
    transform: "translate(6.118 18.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13299",
    "data-name": "Path 13299",
    d: "M164.256,273.039H152.02a1.02,1.02,0,1,1,0-2.039h12.236a1.02,1.02,0,0,1,0,2.039Z",
    transform: "translate(-151 -271)",
    fill: "#4cb3c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6387",
    "data-name": "Group 6387",
    transform: "translate(6.118 22.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13300",
    "data-name": "Path 13300",
    d: "M164.256,333.039H152.02a1.02,1.02,0,1,1,0-2.039h12.236a1.02,1.02,0,0,1,0,2.039Z",
    transform: "translate(-151 -331)",
    fill: "#4cb3c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6388",
    "data-name": "Group 6388",
    transform: "translate(6.118 26.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13301",
    "data-name": "Path 13301",
    d: "M160.177,393.039H152.02a1.02,1.02,0,1,1,0-2.039h8.157a1.02,1.02,0,0,1,0,2.039Z",
    transform: "translate(-151 -391)",
    fill: "#4cb3c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Docs_4_",
    transform: "translate(74.256 14.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6393",
    "data-name": "Group 6393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6389",
    "data-name": "Group 6389",
    transform: "translate(0 12.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13302",
    "data-name": "Path 13302",
    d: "M256,393.039h2.039a1.02,1.02,0,1,0,0-2.039H256Z",
    transform: "translate(-256 -391)",
    fill: "#4cb3c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6390",
    "data-name": "Group 6390",
    transform: "translate(0 8.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13303",
    "data-name": "Path 13303",
    d: "M256,333.039h6.118a1.02,1.02,0,1,0,0-2.039H256Z",
    transform: "translate(-256 -331)",
    fill: "#4cb3c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6391",
    "data-name": "Group 6391",
    transform: "translate(0 4.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13304",
    "data-name": "Path 13304",
    d: "M256,273.039h6.118a1.02,1.02,0,1,0,0-2.039H256Z",
    transform: "translate(-256 -271)",
    fill: "#4cb3c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6392",
    "data-name": "Group 6392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13305",
    "data-name": "Path 13305",
    d: "M256,213.039h6.118a1.02,1.02,0,1,0,0-2.039H256Z",
    transform: "translate(-256 -211)",
    fill: "#4cb3c4"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon-doc.25c671ba170b424df3a504b6a3c05776.svg";
export { ForwardRef as ReactComponent };